// Creator app hooks

export {
  useCreateTempBot,
  type UseCreateTempBotOptions,
  type CreateTempBotRequest,
  type CreateTempBotResponse,
  type CreateTempBotError,
} from './useCreateTempBot';

export {
  useFileUpload,
  type UseFileUploadOptions,
  type UseFileUploadReturn,
  type FileUploadResponse,
  type FileUploadError,
} from './useFileUpload';

export {
  useImageUpload,
  type UseImageUploadOptions,
  type UseImageUploadReturn,
  type ImageUploadResponse,
  type ImageUploadError,
} from './useImageUpload';

export {
  useUrlExtraction,
  type UseUrlExtractionOptions,
  type UseUrlExtractionReturn,
  type ExtractUrlResponse,
  type ExtractUrlError,
  type ExtractionSummary,
} from './useUrlExtraction';

export {
  useGoogleExtraction,
  type UseGoogleExtractionOptions,
  type UseGoogleExtractionReturn,
  type ExtractGoogleResponse,
  type ExtractGoogleErrorResponse,
  type GoogleExtractionErrorCode,
} from './useGoogleExtraction';

export {
  useTextContentSave,
  type UseTextContentSaveOptions,
  type UseTextContentSaveReturn,
} from './useTextContentSave';

export {
  useLossPreventionWarning,
  type UseLossPreventionWarningOptions,
} from './useLossPreventionWarning';

export { useLanguagePreference } from './useLanguagePreference';

export {
  useBots,
  type BotWithStats,
  type UseBotsParams,
} from './useBots';

export {
  useBot,
  type BotData,
} from './useBot';

export {
  useUpdateBot,
  type UpdateBotPayload,
} from './useUpdateBot';

export { useReferralCapture } from './useReferralCapture';

export {
  useUpdateRefreshSettings,
  useManualRefresh,
} from './useContentRefresh';
